// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"SP-z","categoryName":"TP-z","categoryNameSearchHeader":"UP-z","categoryContent":"VP-z","bottomAligned":"WP-z","image":"XP-z","imageNoBackground":"YP-z"};